/**
 * Interface for simple login routes
 */
export interface SimpleLoginRoutes<RP, AdditionalInfo = void> {
    /**
     * Build a one-time password for a user in the database
     * @param params
     * @param params.login Login of a user
     * @param params.additionalInfo Additional info you can add on route call
     * ! Be careful of usage of additionalInfo server-side, as route can be forged for attacks
     */
    buildPassword(params: { login: string, additionalInfo?: AdditionalInfo }, routeParams?: RP): Promise<SimpleLoginResponse>;

    /** Test if the user is connected */
    amIConnected(params: void, routeParams?: RP): Promise<boolean>;

    /** Logout if possible, without server redirection */
    logout(params: void, routeParams?: RP): Promise<void>;
}

export enum BuildPasswordStatus {
    /** Operation is successful */
    SUCCESS = "success",
    /** Error when getting User Infos */
    WRONG_INFOS = "wrong_infos",
    /** Error when sending password to user */
    SEND_ERROR = "send_error",
    /** Unknown error */
    UNKNOWN_ERROR = "unknown_error"
}

export type SimpleLoginResponse = { status: BuildPasswordStatus, login?: string };